import React from "react";

export default function TrainingEnquiryPage() {
  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const name = formData.get("name") || "";
    const email = formData.get("email") || "";
    const phone = formData.get("phone") || "";
    const interest = formData.get("interest") || "";
    const level = formData.get("level") || "";
    const message = formData.get("message") || "";

    const subject = encodeURIComponent(
      `Training enquiry from ${name || "Lash Dollz Vk Beauty website"}`,
    );
    const bodyLines = [
      `Name: ${name}`,
      `Email: ${email}`,
      phone ? `Phone: ${phone}` : "",
      interest ? `Training interest: ${interest}` : "",
      level ? `Experience level: ${level}` : "",
      "",
      "Message:",
      message,
    ].filter(Boolean);

    const body = encodeURIComponent(bodyLines.join("\n"));

    // Open the user's email client with a prefilled email to your address.
    window.location.href = `mailto:lashdollzvk@gmail.com?subject=${subject}&body=${body}`;

    form.reset();
  };

  return (
    <div className="pb-12">
      <header className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="text-[11px] uppercase tracking-[0.25em] text-neutral-500">
            In-person trainings
          </p>
          <h1 className="text-2xl font-medium tracking-tight text-neutral-900 md:text-3xl">
            Lash & brow training at Lash Dollz Vk Beauty
          </h1>
          <p className="mt-3 max-w-xl text-sm text-neutral-600">
            Enquire about in-person classic, hybrid lash and brow trainings in
            Tralee, Co. Kerry. Online trainings are coming soon – for now, all
            education is delivered face to face.
          </p>
        </div>
        <div className="grid gap-3 md:w-64">
          <div className="overflow-hidden rounded-2xl border border-neutral-200 bg-white">
            <img
              src="https://customer-assets.emergentagent.com/job_beauty-lashes-dupe/artifacts/z351wzap_6fa16b6c70f74bd28d03bc535a99315f.jpeg"
              alt="In-person lash training at Lash Dollz Vk Beauty"
              className="h-28 w-full object-cover"
            />
          </div>
          <div className="hidden overflow-hidden rounded-2xl border border-neutral-200 bg-white md:block">
            <img
              src="https://customer-assets.emergentagent.com/job_beauty-lashes-dupe/artifacts/bkbbk5tz_d75b5d8573974b5fbdd30356151b9ccd.jpeg"
              alt="Lash Dollz Vk Beauty certificate of completion"
              className="h-24 w-full object-cover"
            />
          </div>
        </div>
      </header>

      <div className="grid gap-10 md:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)] md:items-start">
        <section>
          <h2 className="text-xs font-medium uppercase tracking-[0.25em] text-neutral-500">
            Training enquiry form
          </h2>
          <p className="mt-2 text-sm text-neutral-600">
            Fill out the form below and share a little about your experience
            level and the type of training you&apos;re interested in. Veronika will
            follow up with available dates, pricing, and course details.
          </p>
          <form onSubmit={handleSubmit} className="mt-5 max-w-lg space-y-4 text-sm">
            <div className="grid gap-4 md:grid-cols-2">
              <div>
                <label className="mb-1 block text-xs font-medium uppercase tracking-[0.2em] text-neutral-700">
                  Name
                </label>
                <input
                  required
                  type="text"
                  name="name"
                  className="h-10 w-full rounded-full border border-neutral-300 bg-white px-4 text-sm outline-none transition-colors duration-150 focus:border-neutral-900"
                  placeholder="Your full name"
                />
              </div>
              <div>
                <label className="mb-1 block text-xs font-medium uppercase tracking-[0.2em] text-neutral-700">
                  Email
                </label>
                <input
                  required
                  type="email"
                  name="email"
                  className="h-10 w-full rounded-full border border-neutral-300 bg-white px-4 text-sm outline-none transition-colors duration-150 focus:border-neutral-900"
                  placeholder="you@example.com"
                />
              </div>
            </div>

            <div className="grid gap-4 md:grid-cols-2">
              <div>
                <label className="mb-1 block text-xs font-medium uppercase tracking-[0.2em] text-neutral-700">
                  Phone (optional)
                </label>
                <input
                  type="tel"
                  name="phone"
                  className="h-10 w-full rounded-full border border-neutral-300 bg-white px-4 text-sm outline-none transition-colors duration-150 focus:border-neutral-900"
                  placeholder="Contact number"
                />
              </div>
              <div>
                <label className="mb-1 block text-xs font-medium uppercase tracking-[0.2em] text-neutral-700">
                  Training interest
                </label>
                <select
                  className="h-10 w-full rounded-full border border-neutral-300 bg-white px-4 text-sm outline-none transition-colors duration-150 focus:border-neutral-900"
                  defaultValue=""
                  name="interest"
                  required
                >
                  <option value="" disabled>
                    Select an option
                  </option>
                  <option value="classic-hybrid-lash">Classic / hybrid lash training</option>
                  <option value="brow-training">Brow training</option>
                  <option value="both">Both lashes & brows</option>
                  <option value="other">Other / custom training</option>
                </select>
              </div>
            </div>

            <div>
              <label className="mb-1 block text-xs font-medium uppercase tracking-[0.2em] text-neutral-700">
                Experience level
              </label>
              <select
                className="h-10 w-full rounded-full border border-neutral-300 bg-white px-4 text-sm outline-none transition-colors duration-150 focus:border-neutral-900"
                defaultValue=""
                name="level"
                required
              >
                <option value="" disabled>
                  Select an option
                </option>
                <option value="beginner">Beginner – new to lashes/brows</option>
                <option value="intermediate">Intermediate – some experience</option>
                <option value="advanced">Advanced – looking to refine skills</option>
              </select>
            </div>

            <div>
              <label className="mb-1 block text-xs font-medium uppercase tracking-[0.2em] text-neutral-700">
                Tell us more
              </label>
              <textarea
                required
                name="message"
                className="min-h-[120px] w-full rounded-3xl border border-neutral-300 bg-white px-4 py-3 text-sm outline-none transition-colors duration-150 focus:border-neutral-900"
                placeholder="Share your goals, preferred dates, and any questions you have about training."
              />
            </div>

            <button
              type="submit"
              className="inline-flex h-10 items-center justify-center rounded-full bg-black px-10 text-[11px] font-medium uppercase tracking-[0.25em] text-white transition-colors duration-150 hover:bg-neutral-800"
            >
              Submit enquiry
            </button>
          </form>
        </section>

        <section className="space-y-4 text-sm text-neutral-600">
          <h2 className="text-xs font-medium uppercase tracking-[0.25em] text-neutral-500">
            Inside Lash Dollz trainings
          </h2>
          <p>
            Trainings are small-group and hands-on, focusing on real models,
            certificate-backed education, and practical skills you can use
            immediately in your business.
          </p>
          <div className="grid gap-3 sm:grid-cols-2">
            <figure className="overflow-hidden rounded-2xl border border-neutral-200 bg-white">
              <img
                src="https://customer-assets.emergentagent.com/job_beauty-lashes-dupe/artifacts/wh30s0qi_011b98079bc14d2ca30e8d5b372baaf8.jpeg"
                alt="Veronika teaching during in-person training"
                className="h-40 w-full object-cover"
              />
            </figure>
            <figure className="overflow-hidden rounded-2xl border border-neutral-200 bg-white">
              <img
                src="https://customer-assets.emergentagent.com/job_beauty-lashes-dupe/artifacts/avj20w0j_481ee4f5f1134993a4c2326f7d1ddc0d.jpeg"
                alt="Training presentation at Lash Dollz Vk Beauty"
                className="h-40 w-full object-cover"
              />
            </figure>
            <figure className="overflow-hidden rounded-2xl border border-neutral-200 bg-white">
              <img
                src="https://customer-assets.emergentagent.com/job_beauty-lashes-dupe/artifacts/tki8x4e8_44c92c7a77e64f48bac6deb3facefeea.jpeg"
                alt="Lash Dollz Vk Beauty training manual"
                className="h-40 w-full object-cover"
              />
            </figure>
            <figure className="overflow-hidden rounded-2xl border border-neutral-200 bg-white">
              <img
                src="https://customer-assets.emergentagent.com/job_beauty-lashes-dupe/artifacts/bkbbk5tz_d75b5d8573974b5fbdd30356151b9ccd.jpeg"
                alt="Lash Dollz Vk Beauty certificate of completion"
                className="h-40 w-full object-cover"
              />
            </figure>
          </div>
        </section>
      </div>
    </div>
  );
}
